import { useCallback } from 'react';

import { Query, QueryUpdaterCallback } from '@shared/api/types';

import { FilterConfiguration } from './DataTable.types';
import { DataTableFilter } from './DataTableFilter';

export type DataTableFiltersProps = {
  filters: FilterConfiguration[];
  query: Query;
  onQueryChange: QueryUpdaterCallback;
};

export function DataTableFilters({ filters, query, onQueryChange }: DataTableFiltersProps) {
  if (!filters.length) {
    return null;
  }

  return (
    <div className="flex flex-wrap gap-3 mb-4">
      {filters.map((filter) => (
        <DataTableFilter key={filter.name} filter={filter} query={query} onQueryChange={onQueryChange} />
      ))}
    </div>
  );
}
